import { ServicePackageTypeVariablePriceEnum } from "@repo/lib";

export interface AssistVariablePrices {
  digitalContactVariablePrice: number | undefined;
  humanContactVariablePrice: number | undefined;
}

export const getAssistVariablePrices = (
  variablePrices: { codPacoteServicosPrecoVariavel: number; valorUnitario: number }[],
): AssistVariablePrices => {
  const priceMap = variablePrices.reduce<Record<number, number>>(
    (acc, { codPacoteServicosPrecoVariavel, valorUnitario }) => {
      acc[codPacoteServicosPrecoVariavel] = valorUnitario;
      return acc;
    },
    {},
  );

  return {
    digitalContactVariablePrice:
      priceMap[ServicePackageTypeVariablePriceEnum.DigitalContact.valueOf()],
    humanContactVariablePrice:
      priceMap[ServicePackageTypeVariablePriceEnum.HumanContact.valueOf()],
  };
};
